import gql from 'graphql-tag'

export const LISTING_FACETS = gql`
    fragment FragmentListingFacets on ListingSearchFacet {
        ... on ListingCategoryFacet {
            __typename
            id
            inputName
            label
            values {
                id
                label
                count
            }
        }
        ... on ListingStorefrontExtraFilterFacet {
            id
            inputName
            label
            values {
                id
                label
                count
            }
        }
        ... on ListingFilterFacet {
            id
            inputName
            label
            filters {
                id
                label
                values {
                    id
                    label
                    count
                }
            }
        }
        ... on ListingStorefrontFilterFacet {
            id
            inputName
            label
            filters {
                id
                label
                values {
                    id
                    label
                    count
                }
            }
        }
        ... on ListingTagsFacet {
            id
            inputName
            label
            values {
                id
                label
                count
            }
        }
        ... on ListingExtraFilterFacet {
            id
            inputName
            label
            values {
                id
                label
                count
            }
        }
        ... on ListingMsrpPriceFacet {
            inputName
            label
            msrpMin
            msrpMax
        }
    }
`
